module.exports = __webpack_public_path__ + "resources/img/main05_jp_m.b0b88ce5011eb00460feed56d0f732ab.png";